/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Batch_Pick_Preset_TitleInputs */



/**
* | output |
* | --- |
* | "Choose export preset" |
*
* @param {Explorer_Info_Batch_Pick_Preset_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_pick_preset_title = /** @type {((inputs?: Explorer_Info_Batch_Pick_Preset_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Pick_Preset_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisissez le préréglage d'exportation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Exportvoreinstellung auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona il preset di esportazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите предустановку экспорта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione el ajuste preestablecido de exportación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择导出预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートプリセットを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात प्रीसेट चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione a predefinição de exportação")
	return /** @type {LocalizedString} */ ("Choose export preset")
});